import trackMovement from "./track-movement-builder.js";
import systemHealth from "./system-health-builder.js";
import vesselEvent from "./vessel-event.js";
import alarm from "./alarm.js";
import createEvent from "./create-event";
import roleFailover from "./role-failover";
import lprWatchlistMatch from "./lpr-watchlist-match.js";
import accessControl from "./access-control.js";
import deviceStatusChange from "./device-status-change.js";

const builder = (rule, collections, shapes, targetAction, hasLinks) => {
	switch (rule.type) {
		case "track-movement":
			return trackMovement(rule, collections, shapes, targetAction, hasLinks);

		case "system-health":
			return systemHealth(rule, collections, targetAction, hasLinks);

		case "vessel-event":
			return vesselEvent(rule, collections);

		case "alarm":
			return alarm(rule, collections, shapes);

		case "create-event":
			return createEvent(rule, collections, shapes);

		case "role-failover":
			return roleFailover();

		case "lpr-watchlist-match":
			return lprWatchlistMatch(rule);

		case "access-control":
			return accessControl(rule, collections, shapes);

		case "device-status-change":
			return deviceStatusChange(rule, collections, shapes);

		default:
			return "";
	}
};

export default builder;
